import React from 'react';
import { Modal, Button, Form, Row, Col, message, DatePicker } from 'antd';
import { _getDate } from '../../../../lib/Helper';
import { SelectSemester, SelectTahunAjaran } from '../../../../components/select';
import dayjs from 'dayjs';
import { dateFormat } from '../../../../constant/constant_format';
const { RangePicker } = DatePicker;

class Filter extends React.Component {

    render() {

        const {open, hideModal, values, setTempTableFilter, setTableFilterFromTemp} = this.props;

        return (
            <Modal
            title="Filter"
            width={300}
            open={open}
            onCancel={hideModal}
            footer={<>
                <Button onClick={hideModal}>Tutup</Button>
                <Button type='primary' onClick={setTableFilterFromTemp}>Terapkan</Button>
            </>}
        >
            <Form
                name="basic"
                autoComplete="off"
                layout="vertical"
            >
                <Form.Item label="Tahun Ajaran">
                    <SelectTahunAjaran
                        allowClear
                        value={values.tahun_ajaran_id}
                        onChange={(val) => {
                            setTempTableFilter("tahun_ajaran_id", val || null);
                            setTempTableFilter("semester_id", null);
                        }}
                    />
                </Form.Item>
                <Form.Item label="Semester">
                    <SelectSemester
                        allowClear
                        value={values.semester_id}
                        tahunAjaranId={values.tahun_ajaran_id}
                        disabled={!values.tahun_ajaran_id}
                        onChange={(val) => {
                            setTempTableFilter("semester_id", val || null);
                        }}
                    />
                </Form.Item>
                <Row gutter={[16, 16]}>
                    <Col xs={24}>
                        <Form.Item label="Periode">
                            <RangePicker
                                value={[
                                    values.tgl_awal ? dayjs(values.tgl_awal, dateFormat) : null,
                                    values.tgl_akhir ? dayjs(values.tgl_akhir, dateFormat) : null
                                ]}
                                onChange={(e, newValue) => {
                                    if (newValue.length === 2 && (newValue[0] && newValue[1])) {
                                        let tglAwal = _getDate(newValue[0]);
                                        let tglAkhir = _getDate(newValue[1]);

                                        let _tglAwal = tglAwal.replace(/-/g, "").replace(/ /g, "").replace(/:/g, "");
                                        let _tglAkhir = tglAkhir.replace(/-/g, "").replace(/ /g, "").replace(/:/g, "");

                                        if (_tglAwal > _tglAkhir) {
                                            return message.warning("Periode yang dimasukkan tidak valid.");
                                        }

                                        setTempTableFilter("tgl_awal", newValue[0]);
                                        setTempTableFilter("tgl_akhir", newValue[1]);
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
        )
    }
}

export default Filter;
